export const FETCH_TAG_REQUEST = 'tag/FETCH_REQUEST';
export const FETCH_TAG_SUCCESS = 'tag/FETCH_SUCCESS';
export const FETCH_TAG_FAILURE = 'tag/FETCH_FAILURE';
export const fetchTagSuccess = (payload) => ({
    type: FETCH_TAG_SUCCESS,
    payload,
});
export function fetchTag(tagSlug, language) {
    return (dispatch, getState, { request }) => {
        let filter = { slug: { $eq: tagSlug } };
        if (language) {
            filter = {
                $and: [{ language: { $eq: language } }, filter],
            };
        }
        return request.post('/v2/tags/query', { query: filter }).then(({ tags }) => {
            if (tags.length) {
                dispatch(fetchTagSuccess(tags[0]));
                return tags[0];
            }
            return Promise.reject({ status: 404 });
        });
    };
}
//# sourceMappingURL=fetch-tag.js.map